import { Box, Typography } from "@mui/material";
import { hierarchyTableStyles } from "../../Styles/hierarchyTableStyles";
import type { HierarchyTableInfoSectionProps } from "../../Types/types";

export const HierarchyTableInfoSection = ({
  note,
}: HierarchyTableInfoSectionProps) => (
  <Box sx={hierarchyTableStyles.infoSection}>
    <Typography sx={hierarchyTableStyles.infoSectionText}>{note}</Typography>
  </Box>
);
